import { Button } from "primereact/button";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useSendResetPasswordEmail } from "../hooks/useGetDataQuery";
import { useToastContext } from "../Lib/Contexts/toastContext";

const SendEmail = () => {

    const { showToast } = useToastContext();

    const {
        mutate: sendResetPasswordEmail,
        isError: isErrorSendResetPasswordEmail,
        isSuccess: isSuccessSendResetPasswordEmail,

    } = useSendResetPasswordEmail();

    useEffect(() => {
        if (isSuccessSendResetPasswordEmail) {
            showToast({ severity: 'success', summary: t('success'), detail: t('emailSentSuccessfully') });
        }
    }, [isSuccessSendResetPasswordEmail]);

    useEffect(() => {
        if (isErrorSendResetPasswordEmail) {
            showToast({ severity: 'error', summary: t('error'), detail: t('errorMessages.resetPassword.emailSendingFailed') });
        }
    }, [isErrorSendResetPasswordEmail]);


    const { t }: any = useOutletContext();
    const [mail, setMail] = useState<any>();
    const [mailError, setMailError] = useState<any>("");

    const navigate = useNavigate();

    const handleSendEmail = () => {
        if (!mail) {
            setMailError('requiredField');
            return false;
        }

        sendResetPasswordEmail({ email: mail });
    }

    return (
        <>
            <img className="flex " src="/forgotPasswordIcon.png" alt="Forgot Password Image" />
            <p className="text-center text-4xl m-0 font-bold mt-4" style={{ color: "#2D3967" }}>{t('forgotYourPassword')}</p>
            <p className="text-center text-lg m-0 mt-2" style={{ color: "#727A99" }}>{t('enterYourMail')}</p>

            <div className="w-full">
                <FloatLabel className="w-full mt-4">
                    <InputText invalid={mailError != "" && !mail}
                        style={{ border: "none", borderRadius: "10px" }}
                        className='p-inputtext-lg w-full' variant="filled" id='email' value={mail}
                        onChange={(e) => setMail(e.target.value)} onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSendEmail();
                            }
                        }} />
                    <label htmlFor='email'>{t('email')}</label>
                </FloatLabel>
                {(mailError != "" && !mail) && <small className='text-red-500 text-xs'>{t(mailError)}</small>}
            </div>

            <Button style={{ backgroundColor: "#6383F4", borderRadius: "10px", border: "none" }}
                className='w-full mt-4' size="large" label={t('sendEmail')} onClick={handleSendEmail} />


            <Button style={{ backgroundColor: "#FFFFFF", borderRadius: "10px", border: "1px solid #2D3967", color: "#2D3967" }}
                className='w-full my-2' size="large" label={t('backToLogin')} icon="pi pi-arrow-left" iconPos="left"
                onClick={() => navigate({ pathname: "/" })} />

        </>
    )
}

export default SendEmail;